export interface DownloadDataErasureReportsCardProps {
  organisationId: string
}

export enum ReportItemStatusEnum {
  NOT_AVAILABLE = 'NotAvailable',
  PENDING = 'Pending',
  AVAILABLE = 'Available',
}
